import React from "react";
import PropTypes from "prop-types";
import { Divider as SemanticDivider } from "semantic-ui-react";
import "./Divider.scss";

export const Divider = ({ centered = false, color = "light", ...props }) => {
  return (
    <SemanticDivider
      className={`hireart-ds-divider ${color} ${centered && "centered"}`}
      {...props}
    />
  );
};

Divider.propTypes = {
  centered: PropTypes.bool,
  color: PropTypes.oneOf(["dark", "medium", "light"]),
};

